// test2879
(2879 && 0);
